import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { SummaryBar } from "../components/summary_bar.js";
import { summaryAData, summaryAOptions } from "../data/summary_A.js";
import { summaryBData, summaryBOptions } from "../data/summary_B.js";
import { summaryC1Data, summaryC1Options } from "../data/summary_C1.js";
import { summaryC2Data, summaryC2Options } from "../data/summary_C2.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h5>{`Takeaways`}</h5>
    <h6>{`Certain frameworks produced more consistent and accurate classifications.`}</h6>
    <p>{`Higher performing frameworks (C and D) more than doubled the percentage of consistent and accurate classifications,
compared to the lowest performing framework (A with no rubric).`}</p>
    <div style={{
      padding: "10px 0px 20px 0px",
      width: "50%",
      minWidth: "320px",
      margin: "auto"
    }}>
    <SummaryBar data={summaryAData} options={summaryAOptions} mdxType="SummaryBar" />
    </div>
    <h6>{`Including a summary rubric of framework dimensions improves classification.`}</h6>
    <p>{`We found a significant decrease in consistent and accurate classifications when users were not provided with a
rubric when making a system classification, compared to instances when a rubric was provided.`}</p>
    <div style={{
      padding: "10px 0px 20px 0px",
      width: "50%",
      minWidth: "320px",
      margin: "auto"
    }}>
    <SummaryBar data={summaryBData} options={summaryBOptions} mdxType="SummaryBar" />
    </div>
    <h6>{`Users were better at classifying an AI system's impact level than autonomy level.`}</h6>
    <p>{`Users consistently assigned the accurate system impact but struggled to consistently assign the accurate level of
system autonomy, across all frameworks. Users were also better at classifying system deployment context than
technical system characteristics.`}</p>
    <div style={{
      padding: "10px 0px 20px 0px",
      textAlign: "center"
    }}>
    <div style={{
        display: "inline-block",
        width: "50%",
        minWidth: "320px"
      }}>
        <SummaryBar data={summaryC1Data} options={summaryC1Options} mdxType="SummaryBar" />
    </div>
    <div style={{
        display: "inline-block",
        width: "50%",
        minWidth: "320px"
      }}>
        <SummaryBar data={summaryC2Data} options={summaryC2Options} mdxType="SummaryBar" />
    </div>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      